import Spinner from "@/svg/spinner-third-duotone-solid.svg?react";
import classNames from "classnames";
import React from "react";

export default function Loader({className, ...props}: React.SVGProps<SVGSVGElement>) {
    return <Spinner className={classNames("animate-spin", className)} {...props} />
}